import { ConfigurationPermissionStatus } from "@/components/configuration";
import { useSystemPermissionHandlers } from "@/components/desktop/system-permissions/shared/system-permissions.hooks";
import { electronModule } from "@/modules/electron";
import { RecallPermissionKind } from "@/modules/electron/types";
import { useAppStore } from "@/store";
import { useCallback } from "react";

export const useOnboardingSystemPermissionsHandlers = (): {
  resolveConfigurationStatus: ({
    kind,
  }: {
    kind: RecallPermissionKind;
  }) => ConfigurationPermissionStatus;
  handleEnablePermission: ({ kind }: { kind: RecallPermissionKind }) => Promise<void>;
  handleOpenPermissionPane: ({ kind }: { kind: RecallPermissionKind }) => Promise<void>;
  restartRequired: boolean;
} => {
  const { store } = useAppStore();
  const systemPermissions = store.systemPermissions;

  const requestPermissionHandler = useCallback(async (permission: RecallPermissionKind) => {
    await electronModule.recall.requestPermission({ permission });
  }, []);

  const openPermissionPaneHandler = useCallback(async (permission: RecallPermissionKind) => {
    await electronModule.recall.openPermissionPane({ permission });
  }, []);

  const {
    resolveConfigurationStatus,
    handleEnablePermission,
    handleOpenPermissionPane,
    restartRequired,
  } = useSystemPermissionHandlers({
    onRequestPermission: requestPermissionHandler,
    onOpenPermissionPane: openPermissionPaneHandler,
    permissionStatusMap: systemPermissions.permissionMap,
  });

  return {
    resolveConfigurationStatus,
    handleEnablePermission,
    handleOpenPermissionPane,
    restartRequired,
  };
};
